export default __webpack_public_path__ + "static/media/tech-cybersecurity.27742b5e.svg";